module.exports = __webpack_public_path__ + "static/media/wirtualne_medale_i_nagrody_za_osiagniecia.8b07e10b.svg";